import { useCallback } from "react";
import { TextField } from "./Parts/index";
import { Button } from "@/components/Buttons";
import { ErrorMessage } from "@/components/Form/Parts/index";
import styles from "@/styles/Form.module.scss";
import { useCheckTokenTimeout } from "@/hooks";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function CouponCodeForm(_ref) {
  let {
    enable,
    register,
    apply,
    error
  } = _ref;
  const {
    checkTokenTimeoutAndRedirectOnError
  } = useCheckTokenTimeout();
  const handleClick = useCallback(async () => {
    var _res$checkTokenTimeou;
    const res = await checkTokenTimeoutAndRedirectOnError();
    if ((res === null || res === void 0 || (_res$checkTokenTimeou = res.checkTokenTimeout) === null || _res$checkTokenTimeou === void 0 ? void 0 : _res$checkTokenTimeou.result) === true && typeof apply === "function") {
      apply();
    }
  }, [apply]);
  if (!enable) return null;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.couponCode,
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.explanation,
      children: /*#__PURE__*/_jsxs("p", {
        children: ["\u30AF\u30FC\u30DD\u30F3\u30B3\u30FC\u30C9\u3092\u304A\u6301\u3061\u306E\u65B9\u306F\u5165\u529B\u5F8C\u3001\u9069\u7528\u30DC\u30BF\u30F3\u3092\u62BC\u3057\u3066\u304F\u3060\u3055\u3044\u3002", /*#__PURE__*/_jsx("br", {}), "\u30AF\u30FC\u30DD\u30F3\u3068\u4ED6\u306E\u5272\u5F15\u30AD\u30E3\u30F3\u30DA\u30FC\u30F3\u304C\u3042\u308B\u5834\u5408\u3001\u6700\u3082\u5272\u5F15\u984D\u306E\u5927\u304D\u3044\u5272\u5F15\u304C\u9069\u7528\u3055\u308C\u307E\u3059\u3002"]
      })
    }), /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(ErrorMessage, {
        msg: error
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.formGroup,
      children: [/*#__PURE__*/_jsx(TextField, {
        ref: register,
        name: "couponCode",
        placeholder: "\u304A\u6301\u3061\u306E\u5834\u5408\u306F\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044"
      }), /*#__PURE__*/_jsx(Button, {
        fillColor: true,
        small: true,
        inline: true,
        onClick: handleClick,
        children: "\u9069\u7528"
      })]
    })]
  });
}